(() => {
  const source = document.querySelector('[data-nh-recent-product]');
  const panel = document.querySelector('[data-nh-recent-panel]');
  if (!source && !panel) return;
  const locale = document.documentElement.lang || 'it';
  const key = 'nh-recent-session-v1-' + locale;
  let items;
  try {
    items = JSON.parse(sessionStorage.getItem(key) || '[]');
    if (!Array.isArray(items)) items = [];
    if (source) {
      const item = {id:source.dataset.id,title:source.dataset.title,url:source.dataset.url,image:source.dataset.image};
      items = [item, ...items.filter(entry => entry.id !== item.id)].slice(0,12);
      sessionStorage.setItem(key,JSON.stringify(items));
    }
  } catch { return; }
  if (!panel) return;
  const render = () => {
    const cartIds = new Set(Array.from(document.querySelectorAll('.nh-cart-page [data-product-id]'),element => element.dataset.productId));
    const grid = panel.querySelector('[data-nh-recent-grid]');
    grid.replaceChildren();
    items.filter(item => !cartIds.has(item.id)).slice(0,4).forEach(item => {
      try {
        const url = new URL(item.url,location.origin);
        const imageUrl = new URL(item.image,location.origin);
        if (url.origin !== location.origin || !url.pathname.includes('/products/') || imageUrl.protocol !== 'https:') return;
        const link = document.createElement('a');
        link.href = url.href;
        const image = document.createElement('img');
        image.src = imageUrl.href;
        image.alt = '';
        image.loading = 'lazy';
        image.width = 420;
        image.height = 420;
        const title = document.createElement('span');
        title.textContent = item.title;
        link.append(image,title);
        grid.append(link);
      } catch {}
    });
    panel.hidden = !grid.childElementCount;
  };
  render();
  document.querySelector('#AjaxCartForm')?.addEventListener('cart-updated',render);
})();
